import { html } from '../application_element/element.js';
import BaseMenu from '../base_menu/element.js';
import '../dot_menu/element.js';

/**
 * An adapter for dot menu, takes items via slot
 *
 * @prop header - Menu header/title (optional)
 * @prop subheader - Menu subheader (optional)
 * @prop showCancel - Should show cancel option? (optional)
 * @prop buttons - This property will be automatically calculated from slotted ef-dot-menu-items
 *
 * @slot default - Menu items
 */

export default class DotMenu2 extends BaseMenu {
  static id = 0;

  static properties = {
    header: { type: String },
    subheader: { type: String },
    showCancel: { type: Boolean },
    buttons: { state: true, type: Array },
    buttonClass: { type: String },
  };

  constructor() {
    super();
    const id = this.constructor.id++;

    this.showCancel = true;
    this.autoId = `dm2-${id}`;
    this.buttons = [];
  }

  /** @internal */
  get instanceId() {
    return this.autoId;
  }

  /** @internal */
  get dotMenuConfig() {
    return {
      header: this.header,
      subheader: this.subheader,
      showCancel: this.showCancel,
      buttons: this.buttons,
    };
  }

  mapButton(button, index) {
    const partName = [...button.part.values()].join(' ');

    return button.isDivider
      ? { isDivider: true }
      : {
          title: button.name,
          action: this.actionFor(`handleClick${index}`),
          icon: button.icon,
          role: button.itemRole,
          partName,
        };
  }

  initButtons() {
    this.buttons = [];

    const dotMenuItems = this.shadowRoot
      .querySelector('slot')
      .assignedElements({ flatten: true });

    dotMenuItems.forEach((button, index) => {
      const buttonConfig = this.mapButton(button, index);

      this.buttons.push(buttonConfig);

      if (buttonConfig.isDivider) return;

      this[`handleClick${index}`] = () => button.handleClick();
    });
  }

  actionFor(method) {
    return {
      menu: 'ef-dot-menu-2',
      id: this.instanceId,
      method: method,
    };
  }

  renderTrigger() {
    return html`
      <button class=${this.buttonClass || 'trigger'} aria-label="toggle button">
        <ef-icon name="ellipsis-h"></ef-icon>
      </button>
    `;
  }

  render() {
    return html`
      <ef-dot-menu .config=${this.dotMenuConfig}>
        <slot
          @slotchange=${this.initButtons}
          @dotMenuItem-updated=${this.initButtons}>
        </slot>
        <slot
          slot="trigger"
          name="trigger"
          @click=${this.openIonicOrNativeMenu}>
          ${this.renderTrigger()}
        </slot>
      </ef-dot-menu>
    `;
  }
}

DotMenu2.registerTagName('ef-dot-menu-2');
DotMenu2.registerCommonActions('ef-dot-menu-2');

customElements.get('ef-dot-menu-2') ||
  customElements.define('ef-dot-menu-2', DotMenu2);
